import { createContext } from 'react';
import { ResolutionConfig } from '../shared/types/binding-types';

export type ResolutionsContextValue = {
  resolutions: ResolutionConfig[];
  activeResolution: ResolutionConfig;
  setActiveResolutionId: (id: string) => void;
  setResolutions: (resolutions: ResolutionConfig[]) => void;
};

export const ResolutionsContext = createContext<ResolutionsContextValue | null>(null);
